import "regenerator-runtime/runtime";
import Axios from "axios";

// Servidor para desarrollo
// const server = "http://192.168.1.71:8000";

// Servidor para producción
const server = "https://lybflow.link";

const api = `${server}/api/login`;
const apiregister = `${server}/api/register`;
const apiforgot = `${server}/api/forgot-password`;
const apiverificationToken  = `${server}/api/verification-token`;
const apiupdatepassword = `${server}/api/update-password`;
const apiempresagetUrl = `${server}/api/getempresainfo`;
const apicuentagetUrl = `${server}/api/getcuentainfo`;

const login = async credentials => {
  let result = await Axios.post(api, credentials)
    .then(res => {
      return res;
    })
    .catch(error => {
      let respuesta = JSON.parse(JSON.stringify(error));
      respuesta.data =  { code: 401 };
      if (error.response.status == 401) {
        return respuesta;
      }
      if (error.response.status == 500) {
        respuesta.data.code = 500;
        return respuesta;
      }
    });
  return result;
};

const register = async request => {
  let result = await Axios.post(apiregister, request)
  .then(res=>{
    return res
  })
  .catch(error => {
    return error.response;
  })
  return result;
};

const forgotPass = async request => {
  let result = await Axios.post(apiforgot, request)
  .then(res => {
    return res;
  })
  .catch(error => {
    return error.response.status

  });
  return result.data;
};

const verificationToken = async request => {

  let result = await Axios.post(apiverificationToken, request)
  .then(res => {
     return res;
    })
    .catch(error => {
      return error.response
    });
    return result.data;
};

const updatePass = async request =>{
  let result = await Axios.post(apiupdatepassword, request)
  .then(res => {
     return res;
    })
    .catch(error => {
      return error.response
    });
    return result.data;

}

const companyInfo = async request =>{
  let result = await Axios.post(apiempresagetUrl, request)
  .then(res => {
    return res.data;
  })
  .catch(error => {
    return error.response.data;
  });

return result;
}
const countInfo = async request =>{
  let result = await Axios.post(apicuentagetUrl, request)
  .then(res => {
    return res.data;
  })
  .catch(error => {
    return error.response.data;
  });

return result;
}

export default () => ({
  login,
  register,
  forgotPass,
  verificationToken,
  updatePass,
  companyInfo,
  countInfo
});
